import React, { useEffect, useRef, useState } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate, useParams } from "react-router";
import ApartmentIcon from "@mui/icons-material/Apartment";
import location from "../../assets/icon/location.png";
import rupees from "../../assets/icon/rupees.png";
import vacancy from "../../assets/icon/people.png";
import img from "../../assets/img/img.png";
import Footer from "../../common/Footer";
// import AllMediaModelApp from "./AllMediaShow";
import { getAllJob } from "../Jobhiringpost/jobsApi";
// import { applyForJob, getAllJobsMarketplace } from "./jobListApi";
import { swalAlertPopProps } from "../../utils/commonUtils";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import course_img from "../../assets/img/courseImg.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { getAllCourses, intrestedApply } from "./coursesApi";

// import { getAllJobsMarketplace } from "./jobListApi";
export default function CourseDetails() {
  //   const [job, setJob] = useState(null);
  const { id } = useParams();
  const [allCourses, setAllCourses] = useState([]);
  const [job, setJob] = useState(null);
  const [relatedCourses, setRelatedCourses] = useState([]);

  const token = sessionStorage.getItem("smbToken");
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [hide, setHide] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();

  const payload = {
    search1: [
      {
        value: "",
      },
    ],
    search2: [
      {
        value: "",
      },
    ],
    search3: [
      {
        value: "",
      },
    ],
  };

  const getCourses = () => {
    getAllCourses(payload, (res) => {
      const list = res?.data?.data?.list || [];

      const selected = list.find((item) => String(item.id) === String(id));

      const related = selected
        ? list.filter(
            (item) => item.instituteId === selected.instituteId,
            //    &&
            //  String(item.id) !== String(id),
          )
        : [];

      setAllCourses(list);
      setJob(selected);
      setRelatedCourses(related);
    });
  };

  const applyIntrested = (id) => {
    if (!token) {
      Swal.fire({
        text: "Please Login First",
        icon: "error",
        ...swalAlertPopProps,
      });
      return;
    }

    intrestedApply({ courseId: id }).then(() => {
      getCourses();
    });
  };

  useEffect(() => {
    getCourses();
    // sliderCourse();
  }, [id]);

  const coursesPrevRef = useRef(null);
  const coursesNextRef = useRef(null);
  const coursesSwiperRef = useRef(null);

  useEffect(() => {
    if (
      coursesSwiperRef.current &&
      coursesPrevRef.current &&
      coursesNextRef.current
    ) {
      coursesSwiperRef.current.params.navigation.prevEl =
        coursesPrevRef.current;
      coursesSwiperRef.current.params.navigation.nextEl =
        coursesNextRef.current;

      coursesSwiperRef.current.navigation.destroy();
      coursesSwiperRef.current.navigation.init();
      coursesSwiperRef.current.navigation.update();
    }
  }, [coursesPrevRef.current, coursesNextRef.current]);

  const courses = [
    {
      id: 1,
      courseID: "01",
      title: "Foundation Of Hair & Beauty",
      salon: "The Beauty Institute",
      location: "Pune",
      duration: "11 Months",
      startingFrom: "01 Jan 2026",
      hasapplied: false,
      icon: course_img,
    },
    {
      id: 2,
      courseID: "02",
      title: "Spa Therapy",
      salon: "The Beauty Institute",
      location: "Pune",
      duration: "11 Months",
      startingFrom: "01 Jan 2026",
      hasapplied: true,
      icon: course_img,
    },
    {
      id: 3,
      courseID: "03",
      title: "Aromatherapy Basics",
      salon: "The Beauty Institute",
      location: "Pune",
      duration: "11 Months",
      startingFrom: "01 Jan 2026",
      hasapplied: false,
      icon: course_img,
    },
  ];

  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");

  const handleInfor = () => {
    if (token) {
      navigate(`/instituteInfo/${job?.instituteId}`);
    } else {
      Swal.fire({
        text: "Please Login First",
        icon: "error",
        ...swalAlertPopProps,
      });
      navigate(`/login`);
    }
  };

  return (
    <>
      <Box sx={{ backgroundColor: "#C0BFFF" }}>
        <Box sx={{ minHeight: "100vh", p: {sm:3, xs:0} }}>
          {/* Back Icon */}
          <KeyboardBackspaceIcon
            onClick={() => navigate("/courses")}
            sx={{ fontSize: 30, color: "#01008B", mb: 2, cursor: "pointer" }}
          />

          {/* Job Card */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              px: { xs: 1.5, sm: 3, md: 10, lg: 20 },
            }}
          >
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Grid container alignItems="center" spacing={3}>
                {/* Logo */}
                <Grid item xs={12} sm={4} md={3} lg={3}>
                  <Box
                    component="img"
                    src={img}
                    alt="Job"
                    sx={{
                      width: { xs: "100%", sm: 180, md: 150, lg: 200 },
                      height: { xs: 180, sm: 180, md: 150, lg: 200 },
                      objectFit: "cover",
                      borderRadius: 2,
                    }}
                  />
                </Grid>

                {/* Job Details */}
                <Grid item xs={12} sm={6} md={9} lg={9}>
                  <Typography
                    sx={{
                      fontSize: { xs: "16px", sm: "22px", md: "38px" },
                      fontWeight: 500,
                    }}
                  >
                    {job?.courseName}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "11px", sm: "13px", md: "15px" },
                      fontWeight: 500,
                      color: "#555555",
                    }}
                  >
                    (Course Id: {job?.id})
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "13px", sm: "16px", md: "18px" },
                      fontWeight: 500,
                      mt: 0.5,
                    }}
                  >
                    {job?.instituteName}
                  </Typography>

                  <Box sx={{ mt: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 0.5,
                        gap: 2,
                      }}
                    >
                      <Box
                        component="img"
                        src={location}
                        alt="Location"
                        sx={{ width: 20, height: 20 }}
                      />
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: 500,
                        }}
                      >
                        {job?.courseCity}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 0.5,
                        gap: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: 500,
                        }}
                      >
                        Duration:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: 500,
                        }}
                      >
                        {job?.courseDuration} Months
                      </Typography>
                    </Box>

                    {/* Starting From */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: 500,
                        }}
                      >
                        Starting From:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: 500,
                        }}
                      >
                        {formatDate(job?.courseStartDate)}
                      </Typography>
                    </Box>

                    <Box
                      onClick={handleInfor}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        border: "2px solid #01008B",
                        borderRadius: "10px",
                        py: 0.8,
                        px: 1.5,
                        mt: 1,
                        width: "fit-content",
                        cursor: "pointer",
                      }}
                    >
                      <ApartmentIcon />

                      <Typography
                        sx={{
                          fontSize: { xs: "14px", sm: "16px" },
                          fontWeight: 600,
                          color: "#01008B",
                        }}
                      >
                        Institute Information
                      </Typography>
                    </Box>
                    <Grid
                      container
                      sx={{
                        position: { xs: "static", md: "absolute" },
                        mt: { xs: 2, md: 0 },
                        bottom: { md: 20 },
                        right: { md: 20 },
                        width: {
                          xs: "100%",
                          sm: "100%",
                          md: "30%",
                          lg: job?.hasApplied !== true ? "20%" : "15%",
                        },
                      }}
                    >
                      <Grid item xs={12}>
                        <Button
                          fullWidth
                          variant="contained"
                          sx={{
                            backgroundColor:
                              job?.hasApplied !== true ? "#01008B" : "green",
                            fontSize: { xs: "14px", sm: "16px", md: "18px" },
                            pointerEvents: job?.hasApplied ? "none" : "auto",
                            borderRadius: "6px",
                            textTransform: "none",
                            fontWeight: 500,
                            "&:hover": {
                              backgroundColor:
                                job?.hasApplied !== true ? "#0201b3" : "green",
                            },
                          }}
                          onClick={() => applyIntrested(job?.id)}
                        >
                          {job?.hasApplied && (
                            <CheckCircleIcon
                              sx={{ fontSize: 20, color: "#2ECC71", mr: 1 }}
                            />
                          )}
                          {job?.hasApplied ? "Applied" : "I am Interested"}
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>

                {/* Apply Button */}
                {/* <Grid item>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#01008B",
                  px: 4,
                  py: 1.2,
                  borderRadius: "6px",
                  textTransform: "none",
                  fontWeight: 500,
                  "&:hover": {
                    backgroundColor: "#0201b3",
                  },
                }}
              >
                Apply
              </Button>
            </Grid> */}
              </Grid>
            </Box>

            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  {/* Course Summary */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}} mb={0.5}>
                    Course Summary
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.courseSummary}{" "}
                  </Typography>

                  {/* Course Discription */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}} mb={0.5}>
                    Course Discription
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.courseDescription}
                  </Typography>

                  {/* Eligibility */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}} mb={0.5}>
                    Eligibility
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.courseEligibility}
                  </Typography>

                  {/* Lecture Mode */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}} mb={0.5}>
                    Lecture Mode
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.onlineLecture && "Online"}
                    {job?.onlineLecture && job?.offlineLecture && " | "}
                    {job?.offlineLecture && "Offline"}
                  </Typography>

                  {/*  Lecture Timing */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}} mb={0.5}>
                    Lecture Timing
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.courseTiming}
                  </Typography>

                  {/* Course Fees */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}} mb={0.5}>
                    Course Fees
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.fees}
                  </Typography>

                  {/* Internship */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}}>
                    Installment / Loan Available for this course.
                  </Typography>
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}} mb={0.5}>
                    {job?.installmentAvailable === true ? "Yes" : "No"}
                  </Typography>
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}}>
                    Internship will be provide.{" "}
                  </Typography>
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}} mb={0.5}>
                    {job?.internshipProvided === true ? "Yes" : "No"}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  {/* Contact Person Number */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}} mb={0.5}>
                    Contact Person Name
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.contactPersonName}
                  </Typography>

                  {/* Contact Person Number */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}} mb={0.5}>
                    Contact Person Number
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.contactPersonMobile}
                  </Typography>

                  {/*  Whatsapp Number */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}} mb={0.5}>
                    Whatsapp Number
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.whatsappNumber}
                  </Typography>

                  {/* Email id */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}} mb={0.5}>
                    Email Id
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.emailId}
                  </Typography>

                  {/* City */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}} mb={0.5}>
                    City
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.courseCity}
                  </Typography>

                  {/* Area */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}} mb={0.5}>
                    Area
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.area}
                  </Typography>

                  {/* Address */}
                  <Typography fontWeight={600} fontSize={{sm:"18px", xs:"16px"}} mb={0.5}>
                    Address
                  </Typography>
                  <Typography fontSize={{sm:"16px", xs:'14px'}} color="#666" mb={2}>
                    {job?.address}
                  </Typography>

                  {/* Perks */}
                </Grid>
              </Grid>
            </Box>
          </Box>

          <Box pb={6} sx={{ px: { xs: 1.5, sm: 3, md: 10, lg: 20 } }}>
            <Typography
              sx={{
                fontSize: { xs: "16px", md: "25px" },
                fontWeight: 600,
                mb: 2,
                mt: 2,
              }}
            >
              Course Available For You
            </Typography>

            <Box
              sx={{
                position: "relative",
                backgroundColor: "#fff",
                borderRadius: "12px",
              }}
            >
              {/* PREV */}
              <Button
                ref={coursesPrevRef}
                sx={{
                  position: "absolute",
                  height: { xs: "40px", sm: "100%" },
                  top: { xs: "50%", sm: "0" },
                  transform: { xs: "translateY(-50%)", sm: "none" },

                  // left: -10,
                  // top: "50%",
                  zIndex: 99,
                  borderTopLeftRadius: 0,
                  width: "40px", // Reduced width
                  minWidth: "40px", // Ensure it doesn't expand
                  padding: "0", // Remove default padding
                  borderTopRightRadius: "10px",
                  borderBottomRightRadius: "10px",
                  backgroundColor: "#01008b85",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "primary.dark",
                  },
                  visibility: isBeginning ? "hidden" : "visible", // for Next
                }}
              >
                <ArrowBackIosNewIcon fontSize="small" />
              </Button>

              {/* NEXT */}
              <Button
                ref={coursesNextRef}
                sx={{
                  position: "absolute",
                  height: { xs: "40px", sm: "100%" },
                  top: { xs: "50%", sm: "0" },
                  transform: { xs: "translateY(-50%)", sm: "none" },

                  bottom: "0",
                  right: "0",
                  zIndex: 99,
                  borderTopLeftRadius: 0,
                  width: "40px", // Reduced width
                  minWidth: "40px", // Ensure it doesn't expand
                  padding: "0", // Remove default padding
                  borderTopRightRadius: "10px",
                  borderBottomRightRadius: "10px",
                  backgroundColor: "#01008b85",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "primary.dark",
                  },
                  visibility: isEnd ? "hidden" : "visible", // for Next
                }}
              >
                <ArrowForwardIosIcon />
              </Button>

              <Swiper
                modules={[Navigation]}
                spaceBetween={20}
                navigation={{
                  prevEl: coursesPrevRef.current,
                  nextEl: coursesNextRef.current,
                }}
                onBeforeInit={(swiper) => {
                  coursesSwiperRef.current = swiper;
                  swiper.params.navigation.prevEl = coursesPrevRef.current;
                  swiper.params.navigation.nextEl = coursesNextRef.current;
                }}
                onSlideChange={(swiper) => {
                  setIsBeginning(swiper.isBeginning);
                  setIsEnd(swiper.isEnd);
                }}
                breakpoints={{
                  0: { slidesPerView: 1.1 },
                  480: { slidesPerView: 2 },
                  768: { slidesPerView: 3 },
                  1024: { slidesPerView: 2.5 },
                }}
              >
                {relatedCourses?.map((course) => (
                  <SwiperSlide key={course.id}>
                    <Box
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        backgroundColor: "#EAEAFF",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                      }}
                    >
                      {/* Left Content */}
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: "16px", sm: "22px", md: "27px" },
                              fontWeight: 600,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              pr: 1,
                              flex: 1,
                            }}
                          >
                            {course?.courseName || "-"}
                          </Typography>

                          <Box
                            component="img"
                            src={course.icon}
                            alt="Course Icon"
                            sx={{
                              width: { xs: 34, sm: 40, md: 46 },
                              height: { xs: 34, sm: 40, md: 46 },
                              borderRadius: "50%",
                              border: "2px solid #27A42D",
                              padding: "4px",
                              backgroundColor: "#FFFFFF",
                              flexShrink: 0,
                            }}
                          />
                        </Box>

                        <Typography
                          sx={{
                            fontSize: { xs: "11px", sm: "13px", md: "15px" },
                            fontWeight: 400,
                            color: "#555555",
                          }}
                        >
                          (Course Id: {course?.id})
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: { xs: "13px", sm: "16px", md: "18px" },
                            fontWeight: 600,
                            // mt: 0.5,
                          }}
                        >
                          {course?.instituteName}
                        </Typography>

                        <Box>
                          {/* Location */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mb: 0.5,
                              gap: 2,
                            }}
                          >
                            <Box
                              component="img"
                              src={location}
                              alt="Location"
                              sx={{ width: 20, height: 20 }}
                            />
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                fontWeight: 500,
                              }}
                            >
                              {course?.courseCity}
                            </Typography>
                          </Box>

                          {/* Duration */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                fontWeight: 500,
                              }}
                            >
                              Duration:
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                fontWeight: 500,
                              }}
                            >
                              {course?.courseDuration}
                            </Typography>
                          </Box>

                          {/* Starting From */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                fontWeight: 500,
                              }}
                            >
                              Starting From:
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                fontWeight: 500,
                              }}
                            >
                              {formatDate(course?.courseStartDate)}
                            </Typography>
                          </Box>
                        </Box>

                        {/* Already Applied */}
                        {/* {course.hasapplied && (
                                                    <Box
                                                        sx={{
                                                            position: "absolute",
                                                            bottom: 20,
                                                            right: 16,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 0.5,
                                                        }}
                                                    >
                                                        <CheckCircleIcon sx={{ fontSize: 16, color: "#27A42D" }} />
                                                        <Typography
                                                            sx={{
                                                                fontSize: 13,
                                                                fontWeight: 600,
                                                                color: "#27A42D",
                                                            }}
                                                        >
                                                            Already Applied
                                                        </Typography>
                                                    </Box>
                                                )} */}
                      </Box>

                      {/* Right Icon */}
                      {/* <Box
                                                sx={{
                                                    width: 60,
                                                    height: 60,
                                                    borderRadius: "50%",
                                                    backgroundColor: "#E6E8FF",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <Box
                                                    component="img"
                                                    src={course.icon}
                                                    alt="Course"
                                                    sx={{ width: 60, height: 60, borderRadius: "50%" }}
                                                />
                                            </Box> */}
                    </Box>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Box>
          </Box>
        </Box>
        <Box sx={{ pt: 5 }}>
          <Footer />
        </Box>
      </Box>
    </>
  );
}
